import expiredTokenErrorIcon from "@/assets/expired-token-error-icon.svg";
import invalidTokenErrorIcon from "@/assets/invalid-token-error-icon.svg";
import tokenAlreadyUsedErrorIcon from "@/assets/token-already-used-error-icon.svg";

export enum LoginErrorScreenEnum {
  ALREADY_USED_TOKEN = 'ALREADY_USED_TOKEN',
  INVALID_TOKEN = 'INVALID_TOKEN',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}

export const backendErrorToLoginErrorScreenMap: Record<string, LoginErrorScreenEnum> = {
  'InvalidAccessKeyError': LoginErrorScreenEnum.INVALID_TOKEN,
  'AccessKeyIsAlreadyInUseError': LoginErrorScreenEnum.ALREADY_USED_TOKEN,
  'ExpiredAccessKeyError': LoginErrorScreenEnum.TOKEN_EXPIRED,
}

export type LoginErrorType = Record<LoginErrorScreenEnum, {imgSrc: string, title: string, description: string}>

export const loginErrorScreenMap: LoginErrorType = {
  ALREADY_USED_TOKEN: {
    imgSrc: tokenAlreadyUsedErrorIcon,
    title: "O token já foi utilizado!",
    description: "O token de acesso informado já foi utilizado"
  },
  INVALID_TOKEN: {
    imgSrc: invalidTokenErrorIcon,
    title: "Token inválido!",
    description: "O token de acesso informado é inválido"
  },
  TOKEN_EXPIRED: {
    imgSrc: expiredTokenErrorIcon,
    title: "Token expirado!",
    description: "O token de acesso informado expirou"
  },
}